var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shuqi",attrs:{"id":"shuqi"}},[_c('img',{staticClass:"imgRender",attrs:{"src":_vm.backUrl,"alt":"图片"}})])}
var staticRenderFns = []

export { render, staticRenderFns }